import { createContext, useState } from "react";

export const ProcessingStatusContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [processingStatuses, setProcessingStatuses] = useState([]);
    const [cardImg, setCardImg] = useState(null);
    const [processingStatus, setProcessingStatus] = useState(null);

    const [processingStatusDialog, setProcessingStatusDialog] = useState(false);

    // Make the context object:
    const processingStatusContext = {
        processingStatuses,
        setProcessingStatuses,
        cardImg,
        setCardImg,
        processingStatusDialog,
        setProcessingStatusDialog,
        processingStatus,
        setProcessingStatus,
    };

    // pass the value in provider and return
    return <ProcessingStatusContext.Provider value={processingStatusContext}>{children}</ProcessingStatusContext.Provider>;
};

export const { Consumer } = ProcessingStatusContext;
